import styled from 'styled-components';

export const DropdownMenuTitle = styled.div`
  color: var(--text-muted);
  font-size: var(--font-size-body-2);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-sm);
  padding: 0.375rem var(--spacing-6) var(--spacing-1);
`;
